export const EXCMCAR_CREATE_RESET = 'EXCMCAR_CREATE_RESET'
export const EXCMCAR_CREATE_SET_CREATED = 'EXCMCAR_CREATE_SET_CREATED'
export const EXCMCAR_CREATE_SET_ERROR = 'EXCMCAR_CREATE_SET_ERROR'
export const EXCMCAR_CREATE_SET_VIOLATIONS = 'EXCMCAR_CREATE_SET_VIOLATIONS'
export const EXCMCAR_CREATE_TOGGLE_LOADING = 'EXCMCAR_CREATE_TOGGLE_LOADING'
